import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '@pos-app/core-ui';
import { BehaviorSubject } from 'rxjs';
import { PIBEmailDetails, PIBEmailList } from '@pos-app/data/lib/models/email';
import { NgIf, AsyncPipe } from '@angular/common';
import { CoreUiModule } from '../../../../../../../../libs/core-ui/src/lib/core-ui.module';

@Component({
    selector: 'app-internal-bulletin-email',
    templateUrl: './internal-bulletin-email.component.html',
    styleUrls: ['./internal-bulletin-email.component.scss'],
    imports: [NgIf, CoreUiModule, AsyncPipe]
})
export class InternalBulletinEmailComponent implements OnInit {
  @Input() isExternalUser: boolean;
  @Input() isProgrammeUser: boolean;
  @Input() isShowRows: boolean;
  title: String = 'ARB Internal Communication';
  internalEmailList: PIBEmailList[] = [];
  internalEmailDetail: PIBEmailDetails;
  private _loadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  loading$ = this._loadingSubject.asObservable();
  get loading(): boolean {
    return this._loadingSubject.value;
  }
  set loading(v: boolean) {
    this._loadingSubject.next(v);
  }

  private _loadingDetailViewSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  loadingDetailView$ = this._loadingDetailViewSubject.asObservable();
  get loadingDetailView(): boolean {
    return this._loadingDetailViewSubject.value;
  }
  set loadingDetailView(v: boolean) {
    this._loadingDetailViewSubject.next(v);
  }

  constructor(private apiService: ApiService) {}

  ngOnInit() {
    this.loading = true;
    this.apiService.fetchInternalEmailList().subscribe((data) => {
      this.internalEmailList = data.emailList || [];
      this.loading = false;
    });
  }

  showPIBEmailDetails(pibEmail) {
    this.loadingDetailView = true;
    this.apiService.fetchPIBEmailDetails({ subject: pibEmail.subject, communicationGroup: pibEmail.communicationGroup }).subscribe((data) => {
      this.internalEmailDetail = data.email || [];
      this.loadingDetailView = false;
    });
  }
}

